var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticStyle: { width: "100%" } },
      [
        _c("el-page-header", {
          staticStyle: { margin: "20px" },
          attrs: {
            content: _vm.$t(
              _vm.formType == "" ? "i18n_Cost" : "i18n_fee_details"
            )
          },
          on: { back: _vm.goBack }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              width: "963px",
              margin: "30px auto",
              display: "flex"
            }
          },
          [
            _c(
              "el-card",
              { staticStyle: { width: "963px", margin: "30px auto" } },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      "font-family": "PingFang SC",
                      "font-weight": "bold",
                      color: "#343434",
                      "margin-bottom": "20px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_Amounts_payable")) +
                        "：" +
                        _vm._s(_vm.price) +
                        " CNY\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "myCursor",
                    staticStyle: { "margin-top": "30px", padding: "0 10px" },
                    on: {
                      click: function($event) {
                        return _vm.Onchange("click", "B")
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        class: [_vm.payType == "B" ? "myCard" : ""],
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                src: require("./../../../assets/wechat.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "18px",
                                  "font-family": "PingFang SC",
                                  "font-weight": "500",
                                  color: "#343434"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_WeChat_Pay")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-checkbox", {
                          staticStyle: { zoom: "150%" },
                          on: {
                            change: function($event) {
                              return _vm.Onchange($event, "B")
                            }
                          },
                          model: {
                            value: _vm.payWay[0].checked,
                            callback: function($$v) {
                              _vm.$set(_vm.payWay[0], "checked", $$v)
                            },
                            expression: "payWay[0].checked"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "myCursor",
                    staticStyle: { "margin-top": "30px", padding: "0 10px" },
                    on: {
                      click: function($event) {
                        return _vm.Onchange("click", "A")
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        class: [[_vm.payType == "A" ? "myCard" : ""]],
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                src: require("./../../../assets/ali.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "18px",
                                  "font-family": "PingFang SC",
                                  "font-weight": "500",
                                  color: "#343434"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_Alipay_payment")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-checkbox", {
                          staticStyle: { zoom: "150%" },
                          on: {
                            change: function($event) {
                              return _vm.Onchange($event, "A")
                            }
                          },
                          model: {
                            value: _vm.payWay[1].checked,
                            callback: function($$v) {
                              _vm.$set(_vm.payWay[1], "checked", $$v)
                            },
                            expression: "payWay[1].checked"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { margin: "30px 10px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.payQuest }
                  },
                  [
                    _c("span", { staticStyle: { padding: "0 30px" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("i18n_Pay_Now")) + " ")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              "before-close": _vm.handleClose,
              title: _vm.$t(
                _vm.payType == "B" ? "i18n_WeChat_Pay" : "i18n_Alipay_payment"
              ),
              visible: _vm.dialogVisible,
              width: "30%",
              center: ""
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("qrcode", {
                  staticStyle: { margin: "0 auto" },
                  attrs: {
                    wid: 270,
                    hei: 270,
                    imgwid: 70,
                    imghei: 70,
                    url: _vm.url
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "margin-top": "30px",
                  "font-size": "18px"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("i18n_Payment_Remaining_Time")) +
                    " " +
                    _vm._s(_vm.countDonwM) +
                    " " +
                    _vm._s(_vm.$t("i18n_minutes")) +
                    " " +
                    _vm._s(_vm.countDonwS) +
                    " " +
                    _vm._s(_vm.$t("i18n_seconds")) +
                    "\n      "
                )
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b405f2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b405f2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/billType/PayOrder.vue
// module id = null
// module chunks = 